import { useCallback } from 'react'

import { YandexMetrikaEvent } from '@/app/constants/metrics'
import { useYandexMetrika } from '@/components/shared/yandex-metrika/hooks/useYandexMetrika'

import { useUserProfileRoute } from '../hooks/useUserProfileRoute'
import { UserProfileScreens } from '../lib/types'
import UserProfileDrawer from './UserProfileDrawer'
import UserProfilePopover from './UserProfilePopover'

type Props = {
  isLoading?: boolean
}

const UserProfile = ({ isLoading = false }: Props) => {
  const { userProfileRoute, setUserProfileRoute, closeUserProfile } =
    useUserProfileRoute()
  const { reachGoal } = useYandexMetrika()

  const isProfileDrawerOpened = Boolean(userProfileRoute)

  const onOpenProfile = useCallback(() => {
    reachGoal(YandexMetrikaEvent.MAIN_PROFILE)
    setUserProfileRoute(UserProfileScreens.Profile)
  }, [reachGoal, setUserProfileRoute])

  return (
    <>
      <UserProfilePopover isLoading={isLoading} onOpenProfile={onOpenProfile} />

      <UserProfileDrawer
        opened={isProfileDrawerOpened}
        userProfileRoute={userProfileRoute}
        setUserProfileRoute={setUserProfileRoute}
        closeUserProfile={closeUserProfile}
      />
    </>
  )
}

export default UserProfile
